<template>
  <div v-if="getPermission.settings.view || getPermission.stc.view">  

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">

          <div v-if="active" class="md-layout-item md-size-15 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.billingDate.startDate">
                <label>Doc Date From</label>
              </datepicker>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.billingDate.endDate">
                <label>Doc Date To</label>
              </datepicker>
            </div>
          </div>


          <div  v-if="active" class="md-layout-item md-size-15 ">
            <div class = "inputBox">
              <md-field>
                <label size="lg" class = "textlabel" for="docType" >Status</label>
                  <md-select v-model="searchRequest.billingStatus">
                  <md-option value="BLC">BLC Bill/Cost Confirm</md-option>
                  <md-option value="LOK">LOK Bill/Cost Locked</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
                <auto-complete-master-data-select
              group="STC_CUSTOMER" label="Partner" :init-value="searchRequest.partner" :on-item-changed="handleCustIDChanged" >
            </auto-complete-master-data-select>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 ">
            <div class = "inputBox">
              <md-field>
                <label>Load#</label>
                <md-input v-model="searchRequest.seqNo"/>
              </md-field>
            </div>
            <!-- <div class = "inputBox">
              <md-field>
                <label>Container#</label>
                <md-input v-model="searchRequest.containerNo"/>
              </md-field>
            </div> -->
          </div>

          <div v-if="active" class="md-layout-item md-size-15">
            <div class = "inputBox">
              <md-field>
                <label>Container#</label>
                <md-input v-model="searchRequest.containerNo"/>
              </md-field>
            </div>
          </div>

          <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/apar/loadlist']">
              <callingApiCenter path=" /api/w/apar/loadlist" :not-display-error="true">
                <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised" ><span class="icons-center material-icons">search</span>Search</md-button>
                <md-button class="md-raised custButton md-primary" v-if="searchRequest.lockUnlock == 'BLC'" @click="doLock" :disabled="!this.getPermission.stcMgtLock.edit && !this.getPermission.stcAcctLock.edit"><span class="icons-center material-icons">lock</span>Lock</md-button>
                <md-button class="md-raised custButton md-accent" v-if="searchRequest.lockUnlock == 'LOK'" @click="doUnLock" :disabled="!this.getPermission.stcMgtLock.edit && !this.getPermission.stcAcctLock.edit"><span class="icons-center material-icons">lock_open</span>UnLock</md-button>
                <md-button class="md-raised custButton" @click="doClear">Clear</md-button>
                <input class = "custSearchBar" @input="clearSelect" type="text"
                      placeholder="Filter Search"
                      v-model="filter"
                      />
                <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
                  <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                  <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
                </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>


    <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                    <tr>
                      <th class="header-cell w2">
                        <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                        <md-tooltip md-direction="top">All</md-tooltip>
                      </th>
                      
                      <th class="header-cell center w5" v-on:click="sortFunction('billingNumRateType')">Doc RateType</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('partner')">Partner</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('containerNo')">Ctnr#</th>

                      <th class="header-cell center w4" v-on:click="sortFunction('rdesc')">Rate Desc</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('amt')">Amt</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('qty')">Qty</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('tol')">Tol</th>

                      <th class="header-cell center w6" v-on:click="sortFunction('pickupLoc')">PickUpFrom</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('deliveryTo')">DeliveryTo</th>

                      <th class="header-cell center w5" v-on:click="sortFunction('chzEndDate')">InGateDate</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">OutGateDate</th>
                      
                      <th class="header-cell center w5" v-on:click="sortFunction('refDoc')">RefDoc#</th>
                      
                      <th class="header-cell center w5" v-on:click="sortFunction('billingDate')">Doc Date</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('customerPO')">CustPO#</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">DO#</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('orderType')">Type</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('agreement')">Agmt</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('adesc')">Desc</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load#</th> 
                      
                      <th class="header-cell center w5" v-on:click="sortFunction('chassisNo')">chassisNo</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('ctnrType')">ctnrType</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('moveInBy')">moveInBy</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('moveInDate')">moveInDate</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('ownChassis')">Own</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('source')">source</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('pf')">PF</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('unit')">Unit</th>

                      <th class="header-cell center w5" v-on:click="sortFunction('createdBy')">CreatedBy</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('createdAt')">Created Date</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('updatedBy')">UpdatedBy</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('updatedAt')">Updated Date</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('remark')">Remark</th>

                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('billingStatus')">Status</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('rateType')">Rate Type</th> -->
                      <!-- <th class="header-cell center w5" v-on:click="sortFunction('settleDate')">Rate Date</th> -->
                    </tr>
                  </thead>
                </table>
              </div>

              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell w2 ">
                        <md-checkbox v-model="item.selected">
                          <!-- <span v-if="hasBeenChanged(item)">*</span> -->
                        </md-checkbox>
                      </td>
                      <td class="body-cell excelBox w5">{{item.billingNumRateType}}</td>  
                      <td class="body-cell excelBox w5">{{item.partner}}</td>
                      <td class="body-cell excelBox w5">{{item.containerNo}}</td>

                      <td class="body-cell excelBox w4">{{item.rdesc}}</td>
                      <td class="body-cell excelBox w3">{{item.amt}}</td>
                      <td class="body-cell excelBox w3">{{item.qty}}</td>
                      <td class="body-cell excelBox w3">{{item.tol}}</td>

                      <td class="body-cell excelBox w6"><master-data-display group="GST_LOCATION" :tag-id="item.pickupLoc"/></td>
                      <td class="body-cell excelBox w6"><master-data-display group="GST_LOCATION" :tag-id="item.deliveryTo"/></td>

                      <td class="body-cell excelBox w5">{{item.chzEndDate | date}}</td>
                      <td class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>
                      <td class="body-cell excelBox w5">{{item.refDoc}}</td> 

                      <td class="body-cell excelBox w5">{{item.billingDate}}</td>
                      <td class="body-cell excelBox w5">{{item.customerPO}}</td> 
                      <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>  
                      <td class="body-cell excelBox w2">{{item.deliveryType}}</td>
                      <td class="body-cell excelBox w3">{{item.agreement}}</td>
                      <td class="body-cell excelBox w3">{{item.adesc}}</td>
                      <td class="body-cell excelBox w5">{{item.seqNo}}</td> 
                      
                      <td class="body-cell excelBox w5">{{item.chassisNo}}</td>
                      <td class="body-cell excelBox w3">{{item.ctnrType}}</td>
                      <td class="body-cell excelBox w5">{{item.moveInBy}}</td>
                      <td class="body-cell excelBox w5">{{item.moveInDate | date}}</td>
                      <td class="body-cell excelBox w2">{{item.ownChassis}}</td>
                      <td class="body-cell excelBox w2">{{item.source}}</td>
                      <td class="body-cell excelBox w2">{{item.pf}}</td>
                      <td class="body-cell excelBox w3">{{item.unit}}</td>

                      <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                      <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell excelBox w5">{{item.remark}}</td>

                      <!-- <td class="body-cell excelBox w5">{{item.billingStatus}}</td>  -->
                      <!-- <td class="body-cell excelBox w5">{{item.rateType}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.settleDate}}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

.icons-center {
      vertical-align: middle;
      margin-right: 10px;
      color: yellow;
  }

.inputBox {
    /* border: 1px solid #cacbcc; */
    /* border-radius: 5px; */
    color: #12151a;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 0px 0px 0px 0px;
    margin-top: 5px;
}

.selected {
    background: rgb(230, 194, 248);
}

.center {
    text-align: center;
}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.8rem;
}

.custSearchBar{
    margin: 10px;
    width: 200px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
    color: blue;
}

.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
    color: red;
}


</style>


<script>
  import { mapGetters } from 'vuex';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";

  const getInitSearch = () => ({
    salesOffice: "LGB",
    docType: "LOAD",
    billingNum: null,
    partner: null,
    containerNo: null,
    seqNo: null,
    refDoc: null,
    agreement: null,
    billingStatus: "BLC",
    selected: false,
    lockUnlock: "BLC",
        billingDate: {
      startDate: moment().subtract(1,'months').startOf('d').toDate(),
      endDate: moment().add(0,'months').endOf('d').toDate(),
    },
  });

  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      processRequest: getInitSearch(),
      active: true,
      items: [],
      sortStatus: true,
      filter:"",
      selectAll: false,
    }),

    components: {
      AutocompleteCcicLocationSelect,
      callingApiCenter,
    },

    watch: {
      getlockload(val) {
        this.updateItems(val);
      },
    },

    computed: {
      ...mapGetters([
          'getMasterDataName',
          'getMasterDataByGroup',
          'getMasterDataAsSelectOptionByGroup',
          'getPermission',
          'getUserProfile',
          'getRole',
          'getlockload',
        ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.billingNumRateType).includes(term) ||
                  this.includeNull(row.deliveryOrder).includes(term) ||
                  this.includeNull(row.customerPO).includes(term) ||
                  this.includeNull(row.seqNo).includes(term) ||
                  this.includeNull(row.refDoc).includes(term) ||
                  this.includeNull(row.partner).includes(term) ||
                  this.includeNull(row.containerNo).includes(term) ||
                  this.includeNull(row.chassisNo).includes(term);
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

    },

    async mounted() {
        this.searchRequest.salesOffice = "LGB";
        this.$el.querySelector('#searchTag').click();
        this.updateItems(this.getlockload);
    },

    methods: {
      mouseOver: function(){
          this.active = true;
      },

      mouseLeave: function() {
        this.active = !this.active;
      },

      sortFunction(sortFiled){
                const sorted = _(this.items).sortBy(sortFiled);
                console.log(this.sortStatus)
                this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
      },

      changeSelChkBox() { 
        _(this.filteredRows).forEach(
          it => {
            it.selected = this.selectAll;
          }
        );
        this.updateItems(this.items);
     },

    clearSelect() { 
      this.selectAll = false; 
      _(this.filteredRows).forEach(it => {it.selected = false; });
      this.updateItems(this.items);
    },

      updateItems(itemsSource) {
         var items = JSON.parse(JSON.stringify(itemsSource)) ;
          items.forEach((it) => {
            it.selected ;
          });
          this.items = items;         
        },


      doLock() {
        const load = this.uniqByLast(this.getSelectedItems, it => it.seqNo);
        const apar = this.uniqByLast(this.getSelectedItems, it => it.billingNumRateType);
        //api.post("/api/w/apar/confirm",
        newAPIPost("/api/w/apar/confirm", 
        {
          mode: 'loadLock',
          username: this.getUserProfile.username,
          refList: load.map(it => {
            return {
              seqNo: it.seqNo
            }
          }),
          apar: apar.map(it => {
            return {
              billingNumRateType: it.billingNumRateType
            }
          })
        }
        ).then((res) => {
          this.showDialog = false;
          this.$store.commit("clearApiError");
          this.doSearch();
          window.confirm(res);
        });
      },

      doUnLock() {
        const load = this.uniqByLast(this.getSelectedItems, it => it.seqNo);
        const apar = this.uniqByLast(this.getSelectedItems, it => it.billingNumRateType);
        //api.post("/api/w/apar/confirm",
        newAPIPost("/api/w/apar/confirm", 
        {
          mode: 'loadUnLock',
          username: this.getUserProfile.username,
          refList: load.map(it => {
            return {
              seqNo: it.seqNo
            }
          }),
          apar: apar.map(it => {
            return {
              billingNumRateType: it.billingNumRateType
            }
          })
        }
        ).then((res) => {
          this.showDialog = true;
          this.$store.commit("clearApiError");
          this.doSearch();
          window.confirm(res);
        });
      },

      doSearch() {
        this.active = true;
        this.selectAll = false; 
        if (this.searchRequest.billingDate.startDate == null)
        {
          window.confirm('Doc Date From is required!')
          return;
        }
        if (this.searchRequest.billingDate.endDate == null)
        {
          window.confirm('Doc Date To is required!')
          return;
        }
        console.log(`startdate: ${this.searchRequest.billingDate.startDate.toISOString()} enddate: ${this.searchRequest.billingDate.endDate.toISOString()}`);
        this.processRequest.salesOffice = this.searchRequest.salesOffice;
        this.processRequest.docType = this.searchRequest.docType;
        this.processRequest.billingNum = this.searchRequest.billingNum;
        this.processRequest.partner = this.searchRequest.partner;
        this.processRequest.containerNo = this.searchRequest.containerNo;
        this.processRequest.seqNo = this.searchRequest.seqNo;
        this.processRequest.refDoc = this.searchRequest.refDoc;
        this.processRequest.agreement = this.searchRequest.agreement;
        this.processRequest.billingStatus = this.searchRequest.billingStatus;
        this.processRequest.selected = this.searchRequest.selected;
        this.processRequest.lockUnlock = this.searchRequest.lockUnlock;
        this.processRequest.billingDate.startDate = this.searchRequest.billingDate.startDate;
        this.processRequest.billingDate.endDate = this.searchRequest.billingDate.endDate;
        const p_startdate = this.processRequest.billingDate.startDate.toISOString();
        const p_enddate = this.processRequest.billingDate.endDate.toISOString();
        if (p_startdate.indexOf('T') > 1)
        {
            var dateportion = p_startdate.split('T');
            if (dateportion && dateportion.length == 2)
            {
              this.processRequest.billingDate.startDate = dateportion[0];
            }
        }
        if (p_enddate.indexOf('T') > 1)
        {
            var dateportion = p_enddate.split('T');
            if (dateportion && dateportion.length == 2)
            {
              this.processRequest.billingDate.endDate = dateportion[0];
            }
        }

        //this.$store.dispatch('lockload', this.searchRequest);
        this.$store.dispatch('lockload', this.processRequest);
        if (this.searchRequest.billingStatus == "BLC" ){
          this.searchRequest.lockUnlock = "BLC";
          this.processRequest.lockUnlock = "BLC";
        };
        if (this.searchRequest.billingStatus == "LOK" ){
          this.searchRequest.lockUnlock = "LOK";
          this.processRequest.lockUnlock = "LOK";
        };
       },

      doClear(){
        this.filter = "";
        this.searchRequest = getInitSearch();
        var items = JSON.parse(JSON.stringify(this.items));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

      handleCustIDChanged(id, name){
          // console.log(`handleCustIDChanged`, id, name);
        this.searchRequest.partner = id;
      },

      uniqByLast(data, key){
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      },

      includeNull(field){
            return field==null ? '' : field;
        },
     },
    }
</script>